import { render, staticRenderFns } from "./TestReportTypeDist.vue?vue&type=template&id=2c147bbc&scoped=true&"
import script from "./TestReportTypeDist.vue?vue&type=script&lang=ts&"
export * from "./TestReportTypeDist.vue?vue&type=script&lang=ts&"
import style0 from "./TestReportTypeDist.vue?vue&type=style&index=0&id=2c147bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c147bbc",
  null
  
)

export default component.exports